import React from "react";
import Skeleton from "../../components/Skeleton";
import { getWindowWidth, isMobileScreen } from "../../services/utils";

const MyRatingsSkeletonItem = () => (
  <div style={{ marginBottom: 20, paddingBottom: 16, borderBottom: "1px solid #ebebeb" }}>
    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
      <div style={{ display: "flex", gap: 5 }}>
        <Skeleton style={{ width: 100, height: 25, margin: 0 }} />
        <Skeleton style={{ width: 100, height: 25, margin: 0 }} />
      </div>
      <Skeleton style={{ width: 75, height: 25, margin: 0 }} />
    </div>
    <Skeleton style={{ width: "50%", height: 25, margin: 0, marginBottom: 12 }} />
    <Skeleton style={{ width: "75%", height: 14, margin: 0, marginBottom: 12 }} />
    <Skeleton style={{ width: "35%", height: 20, margin: 0, marginBottom: 12 }} />
    <Skeleton style={{ width: 125, height: 30, margin: 0 }} />

  </div>
)

const MyRatingsSkeletonItemMobile = () => (
  <div style={{ marginBottom: 20, paddingBottom: 16, borderBottom: "1px solid #ebebeb" }}>
    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 12 }}>
      <Skeleton style={{ width: "30%", height: 25, margin: 0 }} />
      <Skeleton style={{ width: "30%", height: 25, margin: 0 }} />
      <Skeleton style={{ width: "30%", height: 25, margin: 0 }} />
    </div>
    <Skeleton style={{ width: "50%", height: 25, margin: 0, marginBottom: 16 }} />
    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 5 }}>
      <Skeleton style={{ width: "25%", height: 25, margin: 0 }} />
      <Skeleton style={{ width: "45%", height: 25, margin: 0 }} />
    </div>
    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 5 }}>
      <Skeleton style={{ width: "40%", height: 25, margin: 0 }} />
      <Skeleton style={{ width: "45%", height: 25, margin: 0 }} />
    </div>
    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 5 }}>
      <Skeleton style={{ width: "45%", height: 25, margin: 0 }} />
      <Skeleton style={{ width: "45%", height: 25, margin: 0 }} />
    </div>
    <Skeleton style={{ width: "75%", height: 40, margin: 0, marginBottom: 12 }} />
    <Skeleton style={{ width: 125, height: 30, margin: 0 }} />

  </div>
)

export const MyRatingsSkeleton = () => {
  const isMobile = isMobileScreen(getWindowWidth());

  return isMobile ? (
    <div>
      <MyRatingsSkeletonItemMobile />
      <MyRatingsSkeletonItemMobile />
    </div>
  ) : (


    <div>
      <MyRatingsSkeletonItem />
      <MyRatingsSkeletonItem />
    </div>


  )
}


// WEBPACK FOOTER //
// ./src/containers/MyRatingsPage/MyRatingsSkeleton.tsx